import { useEffect, useState, useCallback } from 'react';
import {
  isNativeApp as checkNativeApp,
  openNativeScanner as openScanner,
  sendMessageToNative,
} from '@/lib/utils/native-communication';

export interface DeeplinkData {
  type: string;
  deepLink: string;
  payload?: any;
}

export const useNativeApp = () => {
  const [isNativeApp, setIsNativeApp] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkApp = () => {
      const isInWebView = checkNativeApp();
      setIsNativeApp(isInWebView);
      setIsReady(true);

      if (isInWebView) {
        console.log('Running in React Native WebView');
      }
    };

    checkApp();
  }, []);

  const openNativeScanner = () => {
    return openScanner();
  };

  const handleDeeplink = useCallback((deeplinkData: DeeplinkData) => {
    // This will be called by the component that sets up the listener
    return deeplinkData;
  }, []);

  return {
    isNativeApp,
    isReady,
    openNativeScanner,
    sendMessageToNative,
    handleDeeplink,
  };
};
